@use "../../../node_modules/@thelabnyc/breakpoint-sass/stylesheets/breakpoint";
@use "../../styles/layout";

.container {
    margin: 0;
    max-height: 100%;
    overflow-y: scroll;
    padding: 0;

    @include breakpoint.breakpoint(layout.$belowMedium) {
        width: 100%;
    }
}
